import React, { useEffect, useRef, useState } from "react";
import { parseCookies } from "nookies";

// Styles
import "bootstrap/dist/css/bootstrap.min.css";
import "./css/style.css";
import "./css/mobile.css";
import "./css/custom.css";
import "./css/turnstile.css";

import Main from "./jsx";
import { initOneSignal } from "./onesignalSetup";

export const AppSettings = {};
export const Theme = {};

const App = () => {
  const [isOffline, setIsOffline] = useState(!navigator.onLine);
  const [hasPendingData, setHasPendingData] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const { token: _token } = parseCookies();
  const path = useRef(window.location.pathname);
  const r_storeData = localStorage.getItem("r_storeData");



  // Rotas públicas que não precisam de token
  const publicRoutes = ["/login", "/register", "/activate", "/checkout", "/signup", "/testar", "/conectar", "/politica-de-privacidade", "/termos-de-uso"];
  const isPublicRoute = publicRoutes.some(route => window.location.pathname === route || window.location.pathname.startsWith(route));

  if (!_token && !window.location.href.includes("/register") && !window.location.href.includes("/checkout") && !isPublicRoute) {
    if (path.current !== "/login") {
      window.location.assign(`/login`);
      return;
    }
  } else if (_token && r_storeData) {
    if (path.current !== "/register") {
      window.location.assign(`/register`);
      return;
    }
  }

  return (
    <>
      {isOffline && (
        <div className="offline-banner">
          <div>
            Você está offline. Algumas funcionalidades podem estar limitadas.
          </div>
          {hasPendingData && (
            <small>
              Existem dados em cache que serão sincronizados quando voltar
              online.
            </small>
          )}
        </div>
      )}
      <Main isLoading={isLoading} setIsLoading={setIsLoading} token={_token} />
    </>
  );
};

export default App;
